import {createSelector} from '@ngrx/store';


import {AppState} from '../../../reducers/index';
import * as fromUploadableFormReducer from './uploadable-form.reducer';

export const currentState = (state: AppState) => (state[fromUploadableFormReducer.uploadableFormsFeatureKey]);

export const selectAllUploadableForm = createSelector(currentState, fromUploadableFormReducer.selectAll);

export const selectTotalUploadableForm = createSelector(currentState, fromUploadableFormReducer.selectTotal);

export const selectModifiedUploadableForms = createSelector(selectAllUploadableForm, (serviceForms) => {
  return serviceForms.map((serviceForm) => {
    return {
      ...serviceForm
    };
  });
});

export const selectModifiedUploadableFormByUid= (uniqueId) => createSelector(selectAllUploadableForm, (uploadableForms) =>
uploadableForms.find((uploadableForm) => uploadableForm.formUniqueId === uniqueId));
